import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const handleCloseEvent = async (event_id, dispatch) => {
  dispatch(setShowPreloader(true));
  const closeResponse = await AxiosPostMethod(`org/event/close`, { event_id });
  dispatch(setShowPreloader(false));

  if (closeResponse.status === 200) {
    SuccessToast("Event closed successfully.");
    return true;
  }

  if (closeResponse.status === 401) HandleLogout();
  else ErrorToast(closeResponse.data?.message || "Unable to close event.");

  return null;
};

export default handleCloseEvent;
